// Texts of the calm Client earnings layout; mounted under accountant.calm.
export const clientEarningsCalmEn = {
	switchLabel: "Financial view",
	switchClassic: "Current",
	switchCalm: "New (preview)",
	reserveDetails: "Rolling reserves and CAP · Details",
	showDetails: "Show details",
	hideDetails: "Hide details",
	title: "Client earnings",
	view: "Earnings basis",
	paid: "By payouts",
	accrued: "By accruals",
	status: {
		ok: "<b>Reconciled.</b> Every payment of the period is accounted for: paid out, coming in the next payout or awaiting confirmation.",
		mismatch: "<b>Does not reconcile — off by {{amount}}.</b> The amounts not paid out below are incomplete. Do not use them as a total until the difference is cleared up.",
		open: "<b>The period is not closed yet.</b> Documents are issued through {{through}}; {{days}} not calculated yet. Reconciliation will be available once the period closes.",
		openNone: "<b>The period is not closed yet.</b> No documents have been issued for it so far.",
		openThrough: "<b>The period is not closed yet.</b> Documents are issued through {{through}}; the remaining days are not calculated yet.",
		openAmount_one: "Not billed yet: {{amount}} ({{count}} payment).",
		openAmount_other: "Not billed yet: {{amount}} ({{count}} payments).",
		uncovered_one: "<b>{{count}} day without documents.</b> The figures below cover only the days that have documents.",
		uncovered_other: "<b>{{count}} days without documents.</b> The figures below cover only the days that have documents.",
		covered: "All days of the period are covered by documents.",
	},
	tiles: {
		overview: "Turnover for the period",
		overviewHint_one: "{{count}} payment · as on the Overview screen",
		overviewHint_other: "{{count}} payments · as on the Overview screen",
		paidNet: "Paid out (total)",
		paidNetHint: "by the documents of the period",
		accruedNet: "Accrued for payout",
		accruedHint: "by report days",
		notPaid: "Not paid out for the period",
		notPaidHint: "comes later or awaits confirmation",
		notPaidMismatch: "not calculated while the period does not reconcile",
		notPaidOpen: "known once the period closes",
		days: "Days with data",
		daysHint: "in the selected period",
	},
	calc: {
		titlePaid: "Payout breakdown",
		titleAccrued: "Accrual breakdown",
		turnoverDocs: "Turnover by documents",
		turnover: "Turnover",
		fees: "Fees",
		rollingTaken: "Held in rolling reserve",
		rollingReleased: "Released from rolling reserve",
		refunds: "Refunds to customers",
		chargebacks: "Chargebacks",
		oct: "OCT payouts",
		withdrawal: "Withdrawal fee",
		setup: "Setup fee",
		monthly: "Monthly fee",
		netPaid: "Paid out to the client",
		netAccrued: "Accrued for payout",
		rounding: "Rounding difference between the lines and the total, as reported by the server: {{amount}}. Each document rounds to whole cents; the total is the amount billed.",
		empty: "No activity in this period.",
	},
	notPaid: {
		title: "Not paid out for the period",
		next: "Goes into the next payout",
		nextHint: "Payments from the end of the period, billed by a later document. Nothing to do.",
		acquirer: "Awaiting acquirer confirmation",
		acquirerHint: "Will be paid out once the acquirer confirms settlement.",
		stuck_one: "Of these, <b>{{amount}}</b> have waited longer than {{count}} day — worth checking with the acquirer.",
		stuck_other: "Of these, <b>{{amount}}</b> have waited longer than {{count}} days — worth checking with the acquirer.",
		lost: "Some payments were declined by the acquirer and will not be paid out.",
		check_one: "{{count}} to check",
		check_other: "{{count}} to check",
		none: "Nothing awaiting confirmation.",
		atLeast: "at least {{amount}}",
		total: "Total not paid out",
		earlier_one: "This payout also includes <b>{{amount}}</b> for days before the period ({{count}} payment). This is normal.",
		earlier_other: "This payout also includes <b>{{amount}}</b> for days before the period ({{count}} payments). This is normal.",
		payments_one: "{{count}} payment",
		payments_other: "{{count}} payments",
		shown: "Showing {{shown}} of {{total}}",
		waiting_zero: "waiting under a day",
		waiting_one: "waiting {{count}} day",
		waiting_other: "waiting {{count}} days",
		document: "Document No. {{id}}",
		payment: "Payment No. {{id}}",
	},
	more: "Details",
	docs: {
		title: "Documents for the period",
		pending: "not completed yet: {{amount}}",
		number: "Document",
		type: "Type",
		status: "Status",
		period: "For dates",
		coverage: "In the period",
		amount: "Amount",
		full: "fully",
		partial: "partly",
		empty: "No documents for this currency.",
	},
	channels: {
		title: "By channel",
		channel: "Channel",
		turnover: "Turnover",
		fees: "Fees",
		taken: "To reserve",
		released: "From reserve",
		refunds: "Refunds",
		chargebacks: "Chargebacks",
		net: "Payable",
		total: "All channels",
		empty: "No channel data for this currency.",
	},
	recon: {
		title: "Detailed reconciliation",
		hint: "for checking differences",
		shift: "The acquirer sends a day's report the next day, so “by report days” is a slightly different set of payments than “by documents”. Both figures are correct.",
		shiftAmounts: "Came from reports before the period: {{earlier}}. Went to reports after the period: {{later}}.",
		unexplained: "Unexplained difference: {{amount}}.",
		reportDays: "By report days",
		inside: "Within the period",
		outside: "Outside the period",
		outsideDays: "dates outside: {{days}}",
		noOutside: "no dates outside",
		notes: "Server notes",
	},
	formula: {
		created: "created in the period",
		deferred: "into the next payout",
		notSettled: "awaiting confirmation",
		earlier: "for days before the period",
		byDocuments: "by documents",
		outOfReports: "in reports after the period",
		intoReports: "from reports before the period",
		beyond: "billed past the period end",
		byReportDays: "by report days",
	},
	statementType: { daily: "Daily", weekly: "Weekly", monthly: "Monthly" },
	statementStatus: { created: "Not completed", completed: "Completed", paid: "Paid" },
};

export const clientEarningsCalmRu = {
	switchLabel: "Финансовый экран",
	switchClassic: "Текущий",
	switchCalm: "Новый (тест)",
	reserveDetails: "Роллинги и CAP · Подробности",
	showDetails: "Показать подробности",
	hideDetails: "Скрыть подробности",
	title: "Доходы клиента",
	view: "Основание расчёта",
	paid: "По выплатам",
	accrued: "По начислениям",
	status: {
		ok: "<b>Сверка сходится.</b> Весь оборот периода учтён: выплачен, перейдёт в следующую выплату или ждёт подтверждения.",
		mismatch: "<b>Сверка не сходится на {{amount}}.</b> Суммы «Не выплачено» ниже неполные. Не используйте их как итог, пока расхождение не разобрано.",
		open: "<b>Период ещё не закрыт.</b> Документы выставлены по {{through}}; {{days}} ещё не рассчитаны. Сверка будет после закрытия периода.",
		openNone: "<b>Период ещё не закрыт.</b> Документов за него пока нет.",
		openThrough: "<b>Период ещё не закрыт.</b> Документы выставлены по {{through}}; остальные дни ещё не рассчитаны.",
		openAmount_one: "Ещё не выставлено: {{amount}} ({{count}} платёж).",
		openAmount_few: "Ещё не выставлено: {{amount}} ({{count}} платежа).",
		openAmount_many: "Ещё не выставлено: {{amount}} ({{count}} платежей).",
		openAmount_other: "Ещё не выставлено: {{amount}} ({{count}} платежа).",
		uncovered_one: "<b>{{count}} день без документов.</b> Цифры ниже — только по дням, за которые документы есть.",
		uncovered_few: "<b>{{count}} дня без документов.</b> Цифры ниже — только по дням, за которые документы есть.",
		uncovered_many: "<b>{{count}} дней без документов.</b> Цифры ниже — только по дням, за которые документы есть.",
		uncovered_other: "<b>{{count}} дня без документов.</b> Цифры ниже — только по дням, за которые документы есть.",
		covered: "Все дни периода покрыты документами.",
	},
	tiles: {
		overview: "Оборот за период",
		overviewHint_one: "{{count}} платёж · как на экране Overview",
		overviewHint_few: "{{count}} платежа · как на экране Overview",
		overviewHint_many: "{{count}} платежей · как на экране Overview",
		overviewHint_other: "{{count}} платежа · как на экране Overview",
		paidNet: "Выплачено (итого)",
		paidNetHint: "по документам периода",
		accruedNet: "Начислено к выплате",
		accruedHint: "по дням отчётов",
		notPaid: "Не выплачено за период",
		notPaidHint: "придёт позже или ждёт подтверждения",
		notPaidMismatch: "не считается, пока сверка не сходится",
		notPaidOpen: "станет известно после закрытия периода",
		days: "Дней с данными",
		daysHint: "в выбранном периоде",
	},
	calc: {
		titlePaid: "Состав выплаты",
		titleAccrued: "Состав начисления",
		turnoverDocs: "Оборот по документам",
		turnover: "Оборот",
		fees: "Комиссии",
		rollingTaken: "Удержано в резерв (rolling)",
		rollingReleased: "Возвращено из резерва",
		refunds: "Возвраты покупателям",
		chargebacks: "Чарджбэки",
		oct: "Выплаты OCT",
		withdrawal: "Комиссия за вывод",
		setup: "Setup-комиссия",
		monthly: "Ежемесячная комиссия",
		netPaid: "Выплачено клиенту",
		netAccrued: "Начислено к выплате",
		rounding: "Разница округления между строками и итогом по данным сервера: {{amount}}. Каждый документ округляет суммы до центов; итог — это выставленная сумма.",
		empty: "За этот период активности нет.",
	},
	notPaid: {
		title: "Не выплачено за период",
		next: "Перейдёт в следующую выплату",
		nextHint: "Платежи конца периода, выставленные более поздним документом. Делать ничего не нужно.",
		acquirer: "Ждёт подтверждения эквайера",
		acquirerHint: "Будет выплачено, когда эквайер подтвердит расчёт.",
		stuck_one: "Из них <b>{{amount}}</b> ждут дольше {{count}} дня — их стоит выяснить у эквайера.",
		stuck_few: "Из них <b>{{amount}}</b> ждут дольше {{count}} дней — их стоит выяснить у эквайера.",
		stuck_many: "Из них <b>{{amount}}</b> ждут дольше {{count}} дней — их стоит выяснить у эквайера.",
		stuck_other: "Из них <b>{{amount}}</b> ждут дольше {{count}} дня — их стоит выяснить у эквайера.",
		lost: "Часть платежей эквайер отклонил — они не будут выплачены.",
		check_one: "{{count}} проверить",
		check_few: "{{count}} проверить",
		check_many: "{{count}} проверить",
		check_other: "{{count}} проверить",
		none: "Платежей, ждущих подтверждения, нет.",
		atLeast: "не меньше {{amount}}",
		total: "Итого не выплачено",
		earlier_one: "Также в эту выплату вошло <b>{{amount}}</b> за дни до периода ({{count}} платёж). Это нормально.",
		earlier_few: "Также в эту выплату вошло <b>{{amount}}</b> за дни до периода ({{count}} платежа). Это нормально.",
		earlier_many: "Также в эту выплату вошло <b>{{amount}}</b> за дни до периода ({{count}} платежей). Это нормально.",
		earlier_other: "Также в эту выплату вошло <b>{{amount}}</b> за дни до периода ({{count}} платежа). Это нормально.",
		payments_one: "{{count}} платёж",
		payments_few: "{{count}} платежа",
		payments_many: "{{count}} платежей",
		payments_other: "{{count}} платежа",
		shown: "Показано {{shown}} из {{total}}",
		waiting_zero: "ждёт меньше суток",
		waiting_one: "ждёт {{count}} день",
		waiting_few: "ждёт {{count}} дня",
		waiting_many: "ждёт {{count}} дней",
		waiting_other: "ждёт {{count}} дня",
		document: "Документ №{{id}}",
		payment: "Платёж №{{id}}",
	},
	more: "Подробнее",
	docs: {
		title: "Документы периода",
		pending: "не завершены: {{amount}}",
		number: "Документ",
		type: "Тип",
		status: "Статус",
		period: "За даты",
		coverage: "В периоде",
		amount: "Сумма",
		full: "полностью",
		partial: "частично",
		empty: "По этой валюте документов нет.",
	},
	channels: {
		title: "По каналам",
		channel: "Канал",
		turnover: "Оборот",
		fees: "Комиссии",
		taken: "В резерв",
		released: "Из резерва",
		refunds: "Возвраты",
		chargebacks: "Чарджбэки",
		net: "К выплате",
		total: "Все каналы",
		empty: "По этой валюте нет данных по каналам.",
	},
	recon: {
		title: "Подробная сверка",
		hint: "для проверки расхождений",
		shift: "Эквайер присылает отчёт за день на следующий день. Поэтому «по дням отчётов» — немного другой набор платежей, чем «по документам». Обе цифры верны.",
		shiftAmounts: "Пришло из отчётов до периода: {{earlier}}. Ушло в отчёты после периода: {{later}}.",
		unexplained: "Необъяснённая разница: {{amount}}.",
		reportDays: "По дням отчётов",
		inside: "Внутри периода",
		outside: "Вне периода",
		outsideDays: "даты вне периода: {{days}}",
		noOutside: "дат вне периода нет",
		notes: "Примечания сервера",
	},
	formula: {
		created: "создано за период",
		deferred: "в следующую выплату",
		notSettled: "ждёт подтверждения",
		earlier: "за дни до периода",
		byDocuments: "по документам",
		outOfReports: "в отчётах после периода",
		intoReports: "из отчётов до периода",
		beyond: "выставлено за концом периода",
		byReportDays: "по дням отчётов",
	},
	statementType: { daily: "Ежедневный", weekly: "Еженедельный", monthly: "Ежемесячный" },
	statementStatus: { created: "Не завершён", completed: "Завершён", paid: "Оплачен" },
};
